import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core'
import { Router } from '@angular/router'

import { BreadcrumbModule } from 'primeng/breadcrumb'
import { TooltipModule } from 'primeng/tooltip'

import { FlxButtonModule, FlxIconModule } from '@flowx/angular-ui-toolkit'
import { SeverityMarkerComponent } from '@flowx/designer/modules/misconfigurations/components/severity-marker/severity-marker.component'
import {
  BreadcrumbsComponent,
  FlxBreadcrumbItem,
} from '@flowx/designer/shared/components/breadcrumbs/breadcrumbs.component'

@Component({
  selector: 'flx-resource-header',
  imports: [
    FlxButtonModule,
    FlxIconModule,
    BreadcrumbModule,
    BreadcrumbsComponent,
    NgClass,
    TooltipModule,
    SeverityMarkerComponent,
  ],
  templateUrl: './resource-header.component.html',
  styleUrls: ['./resource-header.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  host: { '[class.dark]': 'darkMode()', '[class.light]': '!darkMode()' },
})
export class FlxResourceHeaderComponent {
  #router = inject(Router)
  breadcrumbs = input<FlxBreadcrumbItem[]>([])
  defaultBackMenuItem = input<FlxBreadcrumbItem>()
  previousRoute = computed(() => {
    const breadcrumbs = this.breadcrumbs()
    if (!breadcrumbs) {
      return null
    }
    const nextToLast = breadcrumbs[breadcrumbs.length - 2]

    return nextToLast ?? null
  })
  darkMode = input<boolean>(true)

  /**
   * Misconfiguration errors for the open resource. `null` — the default — renders no badge, which
   * is also what a cold start and a hidden-markers preference resolve to.
   */
  readonly errorCount = input<number | null>(null)

  readonly errorBadgeCount = computed((): number => this.errorCount() ?? 0)

  back(): void {
    const previousRoute = this.previousRoute()

    if (previousRoute) {
      if (previousRoute.routerLink) {
        this.#router.navigate(previousRoute.routerLink, {
          relativeTo: previousRoute.relativeTo,
          queryParamsHandling: previousRoute.queryParamsHandling,
        })
      } else if (previousRoute.command) {
        previousRoute.command({ item: previousRoute })
      }
    } else if (this.defaultBackMenuItem()) {
      if (this.defaultBackMenuItem().routerLink) {
        this.#router.navigate(this.defaultBackMenuItem().routerLink)
      } else if (this.defaultBackMenuItem().command) {
        this.defaultBackMenuItem().command({ item: this.defaultBackMenuItem() })
      }
    } else {
      this.#router.navigate(['./'])
    }
  }
}
